import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { guardianAlertService } from "../../../../services/guardianAlertService";
import { openAlertDetails } from "../../../../utils/appNavigation";
import {
  getAlertSearchErrorMessage,
  isValidAlertCode,
  mapAlertByCodeToDetailsShape,
  normalizeAlertCode,
  pickTicketIdFromAlert,
} from "../../../../utils/guardianAlertByCode";
import {
  SearchBar,
  SearchField,
  SearchInput,
  SearchButton,
  SearchHint,
  SearchError,
} from "./styles";

export default function AlertCodeSearchBar({
  initialCode = "",
  autoSearch = false,
  onSearched,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [code, setCode] = useState(initialCode);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState(null);
  const [autoRan, setAutoRan] = useState(false);

  const openFoundAlert = (alert) => {
  const ticketId = pickTicketIdFromAlert(alert);

  if (!ticketId) {
    setError("Este alerta ainda não possui ticket para visualização.");
    return;
  }

  openAlertDetails(dispatch, navigate, { ticketId });
};

  const handleSearch = async (rawCode = code) => {
    const normalized = normalizeAlertCode(rawCode);

    if (!isValidAlertCode(normalized)) {
      setError("Informe um código de 5 caracteres alfanuméricos.");
      return;
    }

    setSearching(true);
    setError(null);

    try {
      const data = await guardianAlertService.getAlertByCode(normalized);

      if (!data?.success || !data?.alert) {
        setError("Nenhum alerta encontrado com este código.");
        return;
      }

      onSearched?.(data.alert);
      openFoundAlert(data.alert);
    } catch (err) {
      setError(getAlertSearchErrorMessage(err));
    } finally {
      setSearching(false);
    }
  };

  React.useEffect(() => {
    if (!autoSearch || autoRan) return;
    const normalized = normalizeAlertCode(initialCode);
    if (!isValidAlertCode(normalized)) return;

    setAutoRan(true);
    handleSearch(normalized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSearch, autoRan, initialCode]);

  return (
    <SearchBar>
      <SearchField>
        <label htmlFor="alert-code-search">Código do alerta</label>
        <SearchInput
          id="alert-code-search"
          type="text"
          value={code}
          maxLength={5}
          placeholder="Ex.: A1B2C (código do e-mail)"
          autoComplete="off"
          spellCheck={false}
          disabled={searching}
          onChange={(event) => {
            setCode(event.target.value.toUpperCase().replace(/[^0-9A-Z]/gi, ""));
            setError(null);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleSearch();
            }
          }}
        />
        <SearchHint>5 caracteres do e-mail de monitoramento</SearchHint>
      </SearchField>

      <SearchButton type="button" onClick={() => handleSearch()} disabled={searching}>
        {searching ? "Buscando..." : "Buscar"}
      </SearchButton>

      {error ? <SearchError role="alert">{error}</SearchError> : null}
    </SearchBar>
  );
}
